import { inject, injectable } from 'inversify'
import type { RouteRecordRaw } from 'vue-router'
import type RouterBuilderMiddlewareInterface from '@/services/route/routerBuilderMiddleware/types'
import { SERVICE_TYPES } from '@/core/container/types'
import type { FeatureFlagsService } from '@/services/featureFlagsService'
import { FeatureFlags } from '@/services/types'
import { contactsListsFoldersRoute, contactsListsRoute } from '@/routes/user/contacts/contacts'
import { contactsListsFoldersContactListRouteName } from '@/routes/user/contacts/types'
import { ListIdRouteParam } from '@/components/views/contacts/types'

@injectable()
export default class FoldersRouterBuilderMiddleware implements RouterBuilderMiddlewareInterface {
  constructor(@inject(SERVICE_TYPES.FeatureFlagsService) protected readonly featureFlagsService: FeatureFlagsService) {}

  public pipe(routes: RouteRecordRaw[]): RouteRecordRaw[] {
    if (!this.featureFlagsService.isFeatureEnabled(FeatureFlags.Folders)) {
      return routes
    }
    this.swapPaths(routes)
    return routes
  }

  private swapPaths(routes: RouteRecordRaw[]) {
    const lists = routes.find((route) => route.name === contactsListsRoute.name)
    const folders = routes.find((route) => route.name === contactsListsFoldersRoute.name)
    if (lists && folders) {
      ;[lists.path, folders.path] = [folders.path, lists.path]

      folders.children = [
        ...(folders.children ?? []),
        {
          path: `:${ListIdRouteParam}`,
          redirect: (to) => ({
            name: contactsListsFoldersContactListRouteName,
            params: { [ListIdRouteParam]: to.params[ListIdRouteParam] },
          }),
        },
      ]
      return
    }

    routes.forEach((route) => route.children && this.swapPaths(route.children))
  }
}
